export default () => {

  const c = {};
  const init = () => {
    console.log('init contentSec');
    c.root = document.getElementById('content');
    const isPc = window.matchMedia('(min-width: 769px)').matches;
    if (!c.root) {
      return;
    }
    if (isPc) {
      buildInduction();
    }
  }

  // PC（769px以上）の時実行
  const buildInduction = () => {
    c.induction = {};
    const targetArea = '.js-content-induction';
    c.induction.target = c.root.querySelector(targetArea);

    setInductionBgLayer();
    setInductionBgThumbsRotate();

    bindLinkHoverAction();
  }
  // レイヤーの作成 => ３レイヤーが揃うことで文字の切り替わりを表現
  //  第１レイヤー：リンクホバー時の文字色変更用
  //  第２レイヤー：リンクホバー時の白文字部分（クリップパスにより切り取り）
  //  第３レイヤー：リンクホバー時に画像（前）と文字（後）
  const setInductionBgLayer = () => {
    const targetBg = '.js-content-induction-bg';
    c.induction.bg = c.root.querySelector(targetBg);
    const fragmentArea = document.createDocumentFragment();
    const layerIds = ['_second', '_third'];
    layerIds.forEach(lId => {
      const cloneArea = c.induction.target.cloneNode(true);
      cloneArea.classList.remove('_front', 'js-content-induction')
      cloneArea.classList.add(lId)
      fragmentArea.appendChild(cloneArea);
    })
    c.induction.bg.appendChild(fragmentArea)
  }
  // 第２レイヤーのクリップパス、第３レイヤーの画像の傾きをランダムに設定
  const setInductionBgThumbsRotate = () => {
    const targetArea = c.induction.bg.querySelector('._third');
    const thumbs = [].map.call(targetArea.querySelectorAll('img'), img => img.closest('div'));
    const rotateSelectors = ['_p5', '_p20', '_p35', '_m10', '_m10', '_m25', '_m40'];
    c.rotateSelectors = [];
    // console.log(thumbs, rotateSelectors);
    thumbs.forEach(thumb => {
      const sIdx = Math.floor(Math.random() * rotateSelectors.length);
      const addSelector = rotateSelectors[sIdx]
      rotateSelectors.splice(sIdx, 1);
      thumb.classList.add(addSelector);
      c.rotateSelectors.push(addSelector);
    })
  }
  // hover時のアクション定義
  const bindLinkHoverAction = () => {
    const targetLinks = c.induction.target.querySelectorAll('a');
    targetLinks.forEach((link, lIdx) => {
      link.addEventListener('mouseover', () => {
        // console.log('mouseover');
        visibleThumbnail(lIdx)
        syncHoverPos(lIdx)
      })
      link.addEventListener('mouseout', () => {
        // console.log('mouseout');
        resetLinkHOverState();
      })
    })
  }
  const visibleThumbnail = (idx) => {
    const visibleThumbArea = c.induction.bg.querySelector('._third');
    [].filter.call(visibleThumbArea.querySelectorAll('.hm-content__list-item'), (_, i) => i === idx)[0].classList.add('is-visibled')
  }
  const syncHoverPos = (idx) => {
    const syncHoverArea = c.induction.bg.querySelector('._second');
    const calcTargetImage = syncHoverArea.querySelectorAll('img')[idx];
    [].filter.call(syncHoverArea.querySelectorAll('.hm-content__list-item'), (_, i) => i === idx)[0].classList.add('is-hover');
    syncHoverArea.style.clipPath = calcThumbClipPath(c.rotateSelectors[idx], syncHoverArea, calcTargetImage);
  }
  const resetLinkHOverState = () => {
    ['is-hover', 'is-visibled'].forEach(selector => {
      c.induction.bg.querySelector(`.${selector}`).classList.remove(selector);
    })
    c.induction.bg.querySelector('._second').removeAttribute('style')
  }

  // クリップパスの作成
  const calcThumbClipPath = (rotateSelector, frame, img) => {
    const rotateDirection = /_p/.test(rotateSelector); // プラス回転（右回り）の時：true
    const rotateDegree = /([0-9]+)/.exec(rotateSelector)[1];
    const rotateRadian = convertDegree2Radian(rotateDegree);
    const area = {
      x: frame.clientWidth,
      y: frame.clientHeight
    }
    const imgVertical = img.clientHeight;
    const imgHorizontal = img.clientWidth;
    const imgTan =  imgVertical / imgHorizontal;
    const imgRadiusRadian = Math.atan(imgTan);
    const radius = Math.sqrt(Math.pow(imgVertical, 2) + Math.pow(imgHorizontal, 2)) / 2;
    const afterRotateX1Radian = imgRadiusRadian + rotateRadian * (rotateDirection ? 1 : -1);
    const rotateX1Height = Math.abs(Math.sin(afterRotateX1Radian) * radius);
    const rotateX1Width = Math.abs(Math.cos(afterRotateX1Radian) * radius);
    const afterRotateX2Radian = imgRadiusRadian + rotateRadian * (rotateDirection ? -1 : 1);
    // console.log(rotateSelector, imgRadiusRadian * 180 / Math.PI, afterRotateX1Radian * 180 / Math.PI, afterRotateX2Radian * 180 / Math.PI, `isOver90Deg:${isOver90Deg(afterRotateX2Radian)}`);
    const rotateX2Height = Math.abs(Math.sin(afterRotateX2Radian) * radius);
    const rotateX2Width = Math.abs(Math.cos(afterRotateX2Radian) * radius);

    const rotateX1Point = convertAbsolutePosition({
      x: area.x / 2 - rotateX1Width,
      y: area.y / 2 - rotateX1Height
    }, area);
    const rotateX2Point = convertAbsolutePosition({
      x: area.x / 2 + rotateX2Width * (isOver90Deg(afterRotateX2Radian) ? 1 : -1),
      y: area.y / 2 + rotateX2Height * 1
    }, area);
    const rotateX3Point = convertAbsolutePosition({
      x: area.x / 2 + rotateX1Width,
      y: area.y / 2 + rotateX1Height
    }, area);
    const rotateX4Point = convertAbsolutePosition({
      x: area.x / 2 + rotateX2Width * (isOver90Deg(afterRotateX2Radian) ? -1 : 1),
      y: area.y / 2 + rotateX2Height * -1,
    }, area);


    // console.log(rotateX1Point, rotateX2Point, rotateX3Point, rotateX4Point);
    // console.log(`clip-path: polygon(${rotateX1Point.x}% ${rotateX1Point.y}%, ${rotateX2Point.x}% ${rotateX2Point.y}%, ${rotateX3Point.x}% ${rotateX3Point.y}%, ${rotateX4Point.x}% ${rotateX4Point.y}%)`);
    return `polygon(${rotateX1Point.x}% ${rotateX1Point.y}%, ${rotateX2Point.x}% ${rotateX2Point.y}%, ${rotateX3Point.x}% ${rotateX3Point.y}%, ${rotateX4Point.x}% ${rotateX4Point.y}%)`;
  }

  const convertDegree2Radian = (degree) => {
    return degree * Math.PI / 180;
  }
  const convertAbsolutePosition = (point, area) => {
    return {
      x: point.x / area.x * 100,
      y: point.y / area.y * 100
    }
  }
  const isOver90Deg = (radian) => {
    return 90 < radian * 180 / Math.PI;
  }

  init();

  return {}
}
